import type { Affiliate, AffiliateAllowedCampaign, AffiliateCredentialPayload } from '@/types/affiliates'

function normalizeAllowedCampaigns(
  value: AffiliateAllowedCampaign[] | undefined
): AffiliateAllowedCampaign[] {
  if (!Array.isArray(value)) {
    return []
  }

  return value.map((c) => ({
    ...c,
    commission_percent:
      c.commission_percent !== undefined && c.commission_percent !== null
        ? Number(c.commission_percent)
        : undefined,
  }))
}

/** Garante campos de campanha mesmo se a API estiver desatualizada ou em transição. */
export function normalizeAffiliate(affiliate: Affiliate): Affiliate {
  return {
    ...affiliate,
    all_campaigns: affiliate.all_campaigns ?? true,
    allowed_campaigns: normalizeAllowedCampaigns(affiliate.allowed_campaigns),
  }
}

export function normalizeAffiliateCredential(
  affiliate: AffiliateCredentialPayload
): AffiliateCredentialPayload {
  return {
    ...affiliate,
    all_campaigns: affiliate.all_campaigns ?? true,
    allowed_campaigns: normalizeAllowedCampaigns(affiliate.allowed_campaigns),
  }
}
